import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

/**
 * Opens the system share sheet for a link. In the apps it is the native share sheet; in a browser that has Web Share
 * it falls back to that, and otherwise the element is removed. Attach it to a button with
 * data-controller="bridge--share" data-action="bridge--share#share" and set the url, title and text values.
 */
export default class ShareController extends BridgeComponent {
  public static component = 'share';
  public static values = { url: String, title: String, text: String };
  declare private readonly urlValue: string;
  declare private readonly titleValue: string;
  declare private readonly textValue: string;

  public connect(): void {
    super.connect();

    if (!this.enabled && !('share' in navigator)) {
      this.element.remove();
    }
  }

  public share(): void {
    const data = {
      url: this.urlValue,
      title: this.titleValue,
      text: this.textValue
    };

    if (this.enabled) {
      this.send('share', data);
    } else if ('share' in navigator) {
      navigator.share(data).catch(() => undefined);
    }
  }
}
